import React from 'react';
import classnames from 'classnames';
import { CheckStarSolidIcon } from '@fiverr-private/icons';
import { I18n } from '@fiverr-private/i18n-react';
import { business_400 } from '@fiverr-private/sass/helpers/index';

import styles from './index.module.scss';

interface ListProps {
    className?: string;
    items: {
        title: string;
        content: string;
    }[];
}

export const List = (props: ListProps) => {
    const { items, className = '' } = props;

    const listItems = items.map((item, index) => {
        const { title, content } = item;

        return (
            <li className={styles.item} key={index}>
                <div className={styles.iconHolder}>
                    <CheckStarSolidIcon size={24} color={business_400} />
                </div>
                <div>
                    <div className={styles.title}>
                        <strong>
                            <I18n k={title} />
                        </strong>
                    </div>
                    <div>
                        <I18n k={content} />
                    </div>
                </div>
            </li>
        );
    });

    return <ul className={classnames(styles.main, className)}>{listItems}</ul>;
};
